import React, { useEffect, useState } from "react";
import MainCard from "components/MainCard";
import { Table, Spin, Pagination, Button } from "antd";
import { connect } from "react-redux";
import { Grid } from "@mui/material";
import { dispatch } from "store/index";
import { allLeadsColumns } from "components/columns/columns";
import { FetchAllLeads, FetchAllDeatilsLeads, FetchAllLeadsReportOverAll, DeleteAllLeads } from "store/action/index";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import DrawerLeadDetail from "./lead-detail";
import { IoAdd } from "react-icons/io5";
import {
  can_view_leads,
  can_view_leads_details,
  can_view_leads_history,
  an_view_campaign_leads,
} from "helper/permissionsCheck";
import * as XLSX from "xlsx";
import { CiExport } from "react-icons/ci";

const AllLeads = ({ allLeadsData, leadsoverallrepdata }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [loadingD, setLoadingD] = useState(false);
  const [params, setParams] = useState({ page: 1, team_id: localStorage.getItem("teams_id") });
  const [excelLoading, setExcelLoading] = useState(false);
  const [downloadCond, setDownLoadCondition] = useState(false);

  useEffect(() => {
    setLoading(true);
    dispatch(FetchAllLeads({ setLoading: setLoading, params: params }));
  }, [params]);

  const columns = allLeadsColumns({ params, setParams });

  const HandleViewDetailsFunction = (record) => {
    setLoadingD(true);
    let params = { team_id: localStorage.getItem("teams_id") }

    dispatch(
      FetchAllDeatilsLeads({ id: record?.id, setLoadingD: setLoadingD, params })
    );
  };

  const HandleEdit = (record) => {
    navigate("/leads/add-lead", { state: record });
  };

  const HanldeDelete = (record) => {
    setLoading(true)
    let objectpass = {
      id: record?.id, _method: "DELETE",
    }
    let params = { team_id: localStorage.getItem("teams_id") }

    dispatch(DeleteAllLeads({ objectpass, setLoading: setLoading, params }));
  }

  if (can_view_leads_details) {
    columns.push({
      title: "Action",
      key: "actions",
      render: (text, record) => {
        return (
          <div style={{ display: "flex" }}>
            <DrawerLeadDetail loadingD={loadingD}>
              <Button
                type="primary"
                onClick={() => HandleViewDetailsFunction(record)}
              >
                View Details
              </Button>
            </DrawerLeadDetail>
            <Button
              onClick={() => HandleEdit(record)}>Edit</Button>
            <Button
              onClick={() => HanldeDelete(record)}>Delete</Button>
          </div>
        );
      },
    });
  }

  const handlePageChange = (page) => {
    setParams({ ...params, page });
  };

  const exportExcel = () => {
    let questions = leadsoverallrepdata?.question || [];

    const formattedData = (Array.isArray(leadsoverallrepdata?.leads) ? leadsoverallrepdata?.leads : []).map((log) => {
      let row = {
        "Lead Name": log?.name || "",
        "Phone": log?.phone || "",
        "Email": log?.email || "",
        "Call": log?.activities?.find(e => e.name == "Call")?.total_activities || "",
        "Whatsapp": log?.activities?.find(e => e.name == "WhatsApp")?.total_activities || "",
        "SMS": log?.activities?.find(e => e.name == "SMS")?.total_activities || "",
        "Email Activities": log?.activities?.find(e => e.name == "Email")?.total_activities || "",
      };

      questions.forEach((q) => {
        row[q.question] = "";
      });

      log.answers?.forEach(answerObj => {
        let matchedQuestion = questions.find(q => q.id == answerObj.question_id);
        if (matchedQuestion) {
          let answerValue = Array.isArray(answerObj.answer) ? answerObj.answer.join(", ") : answerObj.answer || "";
          row[matchedQuestion.question] = answerValue;
        }
      });

      return row;
    });

    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "SmsLogs");
    XLSX.writeFile(workbook, "AllLeadsReport.xlsx");
  };

  const HandleDownreport = () => {
    setDownLoadCondition(false)
    setExcelLoading(true)
    let paramss = { per_page: "all", team_id: localStorage.getItem("teams_id") }
    dispatch(FetchAllLeadsReportOverAll({ setExcelLoading: setExcelLoading, params: paramss, setDownLoadCondition }));
  }

  useEffect(() => {
    if (downloadCond && Array.isArray(leadsoverallrepdata?.leads) && leadsoverallrepdata?.leads?.length !== 0) {
      exportExcel();
    }
  }, [downloadCond, leadsoverallrepdata])

  return (
    <>
      <div className="mb-4">
        <MainCard>
          <div style={{ display: "flex" }}>
            <Grid container alignItems="center" justifyContent="flex-start">
              <Grid item>
                <span
                  style={{
                    fontSize: "22px",
                    fontWeight: "600",
                  }}
                >
                  All Leads
                </span>
              </Grid>
            </Grid>
            <Grid container alignItems="center" justifyContent="flex-end">
              <div
                style={{ display: "flex", justifyContent: "right", padding: "10px" }}
              >
                <Button
                  disableElevation
                  className="px-2"
                  size="large"
                  type="submit"
                  onClick={HandleDownreport}
                >
                  {excelLoading ? <span>Exporting...</span> : <> <span className="mx-2">
                    <CiExport color="#0055A2" size={26} />
                  </span>
                    All Leads Report</>}
                </Button>
              </div>
              <Grid item>
                <Link to={"/leads/add-lead"}>
                  <Button
                    disableElevation
                    className="px-2"
                    size="large"
                    type="submit"
                  >
                    <span className="mx-2">
                      <IoAdd color="#0055A2" size={26} />
                    </span>
                    Add Lead
                  </Button>
                </Link>
              </Grid>
            </Grid>
          </div>
        </MainCard>
      </div>

      {can_view_leads ? <MainCard>
        <div style={{ overflowX: "auto" }}>
          <Table
            dataSource={allLeadsData?.data ?? []}
            columns={columns}
            pagination={false}
            loading={loading}
          />
        </div>

        <div style={{ textAlign: "center", marginTop: 16 }}>
          <Pagination
            current={allLeadsData?.meta?.current_page || 1}
            total={allLeadsData?.meta?.total || 0}
            pageSize={allLeadsData?.meta?.per_page || 10}
            onChange={handlePageChange}
            showSizeChanger={false}
          />
        </div>
      </MainCard> : <></>}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    allLeadsData: state?.AllLeadsReducer?.allLeads,
    leadsoverallrepdata: state?.OverAllLeadsReportsReducer?.leadsoverallrepdata,
  };
};

export default connect(mapStateToProps)(AllLeads);
